import Container from '@risk-smart/themed-cloudscape-components/container';
import type { FC, ReactNode } from 'react';

import styles from './style.module.scss';

type RegisterDashboardProps = { children: ReactNode };

const RegisterDashboard: FC<RegisterDashboardProps> = ({ children }) => (
  <div className={styles.tightContainer}>
    <Container variant={'default'}>
      <div className={styles.container}>{children}</div>
    </Container>
  </div>
);

export default RegisterDashboard;
